// 内部初始化
import {mockUtil} from '@px/helper/moc';
import {http} from '@px/helper/http';
import {readToken, writeToken, removeToken} from '@px/storage/token';
import {readBid} from '@px/storage/bid';
import {readLanguage} from '@px/storage/lang';
import '@px/streams/subscription';
import '@px/streams-contract/subscription';
import '@px/streams-spot/subscription';
import '@px/streams-margin/subscription';
import {wwData$} from '@px/streams/worker-data';
import {initUrl} from '@px/streams/url';
import {loadPrivateProducts, loadProducts, loadCoinBasic} from '@px/streams/config';
import {checkAuth} from '@px/streams/auth';
import AppView from './AppView.svelte';

export async function main(createDataWorker: () => Worker) {
  initUrl();
  http.init({readToken, writeToken, removeToken, readBid, readLanguage});
  wwData$.init(createDataWorker);
  await Promise.all([checkAuth(), loadPrivateProducts(), loadProducts(), loadCoinBasic()]);
  new AppView({target: document.getElementById('app')});
}
